import React,{useState} from "react";
import { RelativeDiv } from "../../Epics/Grants/Pages/HowItWorks/styles";
import { AccordionRows, HowItWorksStepWrapper, HorizontalLine,FocusDiv } from "./styles";
import TimeLineSteps, {
  GetStepCount,
  AccordionWrapperStep
} from "./TimeLineSteps";
import { CapsuleButton } from "../Commons/commonComponents";

export default ({
  howItWorksDetails,
  stepCount,
  handleScrollToTOp,
  myCustomRef
}) => {
    const [expand, setexpand] = useState();

const triggerScrollToTOp = (expand,subTitle) => {
        setexpand(expand);
        handleScrollToTOp(stepCount, expand,subTitle);
};
const subTitle = `Step${stepCount} ${howItWorksDetails[
    `field_step_${stepCount}_title`
    ]}`
  return (
    <RelativeDiv>
      <AccordionRows data-test="GrantStepMobile">
        <GetStepCount stepCount={stepCount} mobile />
        <HowItWorksStepWrapper>
          <AccordionWrapperStep
            expand={expand}
            stepCount={stepCount}
            howItWorksDetails={howItWorksDetails}
            triggerScrollToTOp={triggerScrollToTOp}
            ref={myCustomRef}
            mobile
          />

          {expand ? (
            <>
              <HorizontalLine />
              <TimeLineSteps
                stepCount={stepCount}
                step="1"
                howItWorksDetails={howItWorksDetails}
                mobile
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="2"
                howItWorksDetails={howItWorksDetails}
                mobile
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="3"
                howItWorksDetails={howItWorksDetails}
                mobile
              />
              <TimeLineSteps
                stepCount={stepCount}
                step="4"
                howItWorksDetails={howItWorksDetails}
                mobile
              />

              <CapsuleButton
                text="Show Less"
                whiteBackground={true}
                disabled={false}
                id="btnShowData"
                height="30px"
                fontSize="14px"
                enableLeft="20px"
                iconType="arrowUp"
                onClick={() => {
                  triggerScrollToTOp(false, subTitle);
                }}
              />
            </>
          ) : (
            <CapsuleButton
              text="Show More"
              whiteBackground={true}
              disabled={false}
              id="btnShowMoreHowItWorks"
              height="30px"
              fontSize="14px"
              enableLeft="20px"
              iconType="arrowDown"
              onClick={() => {
                triggerScrollToTOp(true, subTitle);
              }}
            />
          )}
             <FocusDiv
            data-test="grantStepMobileAccordianFocusDiv"
            id={stepCount}
            onClick={() => {
                !expand &&
                triggerScrollToTOp(true,subTitle);
            }}
          />
        </HowItWorksStepWrapper>
      </AccordionRows>
    </RelativeDiv>
  );
};
